import React from 'react';
import { Link } from 'react-router-dom';
import { FaPaperPlane } from 'react-icons/fa';
import { usePageContent } from '../services/pageContentService';
import HtmlContent from '../components/HtmlContent';
import RawHtmlPage, { isRawHtmlPage } from '../components/RawHtmlPage';

// Content is edited in Admin -> Live Page Contents -> Call for Papers (default: src/data/pageHtml.js)
const submitButton = (
  <div className="mt-8">
    <Link
      to="/upload"
      className="inline-flex items-center gap-2 px-6 py-3 bg-[#03478E] hover:bg-[#023366] text-white text-sm font-bold uppercase tracking-wider rounded-full shadow-md transition"
    >
      <FaPaperPlane className="text-xs" />
      <span>Submit Your Manuscript</span>
    </Link>
  </div>
);

const CallForPapersPage = () => {
  const { content, loading } = usePageContent('call_for_papers');

  // Wait for the saved text rather than flashing the built-in default first
  if (loading) return <div className="min-h-screen" />;

  if (isRawHtmlPage(content)) {
    return <RawHtmlPage html={content.full_content} footer={submitButton} />;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <HtmlContent content={content?.full_content || ''} />
      {submitButton}
    </div>
  );
};

export default CallForPapersPage;
